<!-- Footer -->
<footer>
  <div class="container">
    <div class="row">
      <div class="col-md-4">
        <span class="copyright">Copyright &copy; 2018</span>
      </div>
      <div class="col-md-4">
        <!-- <i id="footer-logo" class="icon-simbolid-nombre"></i> -->
      </div>
      <div class="col-md-4">
        <ul class="list-inline quicklinks">
          <li class="list-inline-item">
            <a [routerLink]="['/politica']">Aviso de Privacidad</a>
          </li>
          <!--<li class="list-inline-item">
            <a href="#">Terms of Use</a>
          </li>-->
        </ul>
      </div>
    </div>
  </div>
</footer>